import React, { Component } from 'react';

import ActionDot, { TOP_LEFT } from 'components/ui-components/action-dot';

import './styles.less';

class EndCurrentTrimButton extends Component {
  render() {
    return (
      <div
        className="trim-bar-button trim-bar-end-current-trim-range-button enabled"
        onClick={this.props.onEndCurrentTrimRange}
      >
        {this.props.showActionDot && <ActionDot position={TOP_LEFT} />}
        <span className="icon" />
        <span className="label">Remove</span>
      </div>
    );
  }
}

export default EndCurrentTrimButton;
